import React, { useContext, useRef, useState } from 'react'
import { Context } from '../context/Context';
import playVideo from '../assets/videos/play_button.png'
import ReactPlayer from 'react-player';
import { useLocation } from 'react-router-dom';


function Videos() {
    const { lang,theme } = useContext(Context);
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);
    const [videoPlay, setVideoPlay] = useState(null);
    const location = useLocation()

    const videoData = location.state.allVideos
    console.log("videoData", videoData)

    const videoUrl = "https://multimedia.ibadatapp.com/awcc/videos/knowledge_about_islam/video_"
    const helper = [1 , 2 , 3, 4, 5, 6 ,7 , 8 ,9, 10 , 11, 12]



    const onPlayFunction = (index) => {
      // audioRef.current.pause()
      // setIsPlaying(false)
    //  setVideoPlay(true)
    setVideoPlay(index)
    }

    const onPauseFunction=()=>{
      setVideoPlay(false)
      // audioRef.current.play()

    }



  return (
    <div className={`border-yellow-400 border-4 absolute pt-20 bg-green max-w-[500px] w-full bg-center bg-cover text-black ${theme === "red" ? "bg-red_bg_pic": "bg-green_bg_pic"}`}>
      <div className=''>
        <div className='w-[50%] flex justify-center mx-auto '>
                <div className={`${theme === "red" ? "bg-red_surah_name_board " :"bg-surah_name_board " } bg-contain flex items-center justify-center pb-2 text-white font-bold bg-no-repeat w-[75%] h-12`}>{videoData?.ramadanCategory}</div>
            </div>
        </div>


<div className='flex items-center justify-center flex-col'>
      {  videoData?.data?.map((data , index) => {
       return    <div className='border-2 border-gray-200 ml-4 bg-[#F3F3F3] min-w-[320px] mt-4 flex justify-center p-2 rounded-lg items-center w-[80%]'>
          <ReactPlayer
            url={data.link}
            width="100%"
            ref={videoRef}
            height="250px"
            onPlay={() => onPlayFunction(index)}
            // onPause={onPauseFunction}
            controls
            playing={videoPlay === index ? true : false}
            playIcon={<img src={playVideo} />}
            light={data.thumbnail}
          />

        </div>


})}

</div>

</div>
  )
}

export default Videos

{/* <div className='videoContainer mx-4 p-2'>
<video  className='h-full w-full' poster={require(`../assets/Thumbnails/video${index + 1}.png`)} playsInline controls>
    <source src={`${videoUrl}${data}.mp4 `} type='video/mp4'>
    </source>
</video>
{/*
<div className='video-description border-2 bg-[#ada6a6] border-black'>
                video description
    </div> */}
